// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + {"12":"profiler","9777":"recorder"}[chunkId] + "." + {"12":"37c47ed4886cbcf4","9777":"f2c82b26ea3d3301"}[chunkId] + ".js";
};